import Base from "./base";

export default class ArticleStockMovement extends Base {
    static moduleName = 'articleStockMovements';
    static relations = {
        oneToMany: ['depot', 'article'],
        manyToMany: ['products']
    }
}